import {
  MEMBER_URL,
  MEMBER_GET_FOLDER,
  MEMBER_SET_AGREE,
} from 'volto-m4-theme-addon/constants/MemberActionTypes';
import config from '@plone/volto/registry';
import { flattenToAppURL } from '@plone/volto/helpers/Url/Url';

export function memberUrl() {
  return {
    type: MEMBER_URL,
    request: {
      op: 'get',
      path: `${config.settings.apiPath}/++api++/@@member-url`,
      headers: {},
    },
  };
}

export function memberGetFolder(memberFolderPath) {
  return {
    type: MEMBER_GET_FOLDER,
    request: {
      op: 'get',
      path: `${config.settings.apiPath}/++api++${flattenToAppURL(
        memberFolderPath,
      )}`,
      headers: {},
    },
  };
}

export function memberSetAgree(memberFolderPath, userAgrees) {
  return {
    type: MEMBER_SET_AGREE,
    request: {
      op: 'patch',
      path: `${config.settings.apiPath}/++api++${flattenToAppURL(
        memberFolderPath,
      )}`,
      data: { user_agrees_to_terms: userAgrees },
      headers: {
        Prefer: 'return=representation',
      },
    },
  };
}
